import { Variable } from '@/types/views/generic';

const getVariablePlainText = (variable?: Variable['text']): string | null =>
  variable && 'value' in variable.content[0]?.content[0]
    ? variable.content[0]?.content[0]?.value
    : null;

export default getVariablePlainText;
